import BlogCover from '@/components/BlogCover';

import coverImage from './images/cover.jpg';
import profileImage from './images/profile.png';

const Component: React.FC = () => (
  <BlogCover
    title="上田仁ブログ"
    coverImage={coverImage}
    profileImage={profileImage}
    description="世界選手権銀メダリスト / 最高世界ランク23位"
  />
);

export default Component;
